import { Box } from "@dehub/theme";
import { CaretRightIcon, HouseIcon } from "@phosphor-icons/react";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classes from "./breadcrumb.module.css";

type Props = Readonly<{ data: { label: string; to?: string }[] }>;

/** Breadcrumb trail (same look as de-network-admin): home icon on the first crumb, caret separators, last crumb is the current page. */
export function Breadcrumb({ data }: Props) {
  const { t } = useTranslation("layout");
  return (
    <Box component="nav" aria-label={t("breadcrumb")}>
      <Box component="ol" className={classes.root}>
        {data.map((item, index) => {
          const last = index === data.length - 1;
          return (
            <React.Fragment key={index}>
              {index > 0 ? (
                <Box component="li" className={classes.separator} aria-hidden="true">
                  <CaretRightIcon size={14} />
                </Box>
              ) : null}
              <Box component="li" className={classes.crumb} aria-current={last ? "page" : undefined}>
                {item.to && !last ? (
                  <Link to={item.to} className={classes.link}>
                    {index === 0 ? <HouseIcon size={14} aria-hidden="true" /> : null}
                    {item.label}
                  </Link>
                ) : (
                  item.label
                )}
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
}
